import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#7D818A",
      d: "M10.977 10 6.852 5.875 8.03 4.697 13.333 10 8.03 15.303l-1.178-1.178z"
    }, null, -1)
  ]))]))
}
export default { render: render }